import { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import Box from '@mui/material/Box'

const useStyles = createUseStyles({
  avatar: ({ size }) => ({
    width: size === 'small' ? 20 : 120,
    height: size === 'small' ? 20 : 120,
    padding: 0,
    borderRadius: '50%'
  })
})

const bufferToBase64 = (buffer) =>
  btoa(new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), ''))

const Avatar = ({ img, size = 'large' }) => {
  const classes = useStyles({ size })
  const [src, setSrc] = useState(null)

  useEffect(() => {
    if (!img) {
      setSrc(null)
      return
    }

    if (typeof img === 'string') {
      setSrc(img)
      return
    }

    if (img.file) {
      if (img.file.type === 'file' && typeof img.file.data === 'string' && img.file.data.startsWith('blob:')) {
        setSrc(img.file.data)
        return
      }

      if (img.file.type === 'Buffer' && Array.isArray(img.file.data)) {
        setSrc('data:image/png;base64,' + bufferToBase64(img.file.data))
        return
      }

      if (img.file instanceof File) {
        const url = URL.createObjectURL(img.file)
        setSrc(url)
        return () => URL.revokeObjectURL(url)
      }
    }
  }, [img])
  return (
    <Box
      component='img'
      className={classes.avatar}
      src={src || undefined}
      alt='avatar'
      draggable={false}
      onDragStart={(e) => e.preventDefault()}
    />
  )
}

export default Avatar
